export default __webpack_public_path__ + "static/media/location_icon.a35332f2.svg";